import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Box, Heading, Modal, Spacer, Text } from '@zillow/constellation-10';
import { LoadingConstants, propertyUtils, SpinnerContainer } from '@zg-rentals/rental-manager-env';
import type { AddressComponents } from '@zg-rentals/rental-manager-env';
import { getStyledTextStyles, styledContainerStyles } from './StyledComponents';

interface PropertyListModalTypes {
  properties?: Array<AddressComponents>;
  onLoadProperties?: () => void;
  isLoading?: boolean;
  onClose: () => void;
}

type formattedProperty = ReturnType<typeof propertyUtils.formatAddress>;

export const UserManagementPropertyListModal = ({
  properties = [],
  onLoadProperties,
  isLoading = false,
  onClose,
}: PropertyListModalTypes) => {
  const dispatch = useDispatch();
  const formattedProperties = properties.map((property: AddressComponents) => propertyUtils.formatAddress(property));
  const [open, setOpen] = React.useState(true);

  React.useEffect(() => {
    if (onLoadProperties) dispatch(onLoadProperties);
  }, []);

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        setOpen(next);
        if (!next) onClose();
      }}
      size={{ base: 'fullScreen', lg: 'md' }}
      header={<Heading level={6}>Properties</Heading>}
      body={
        <Box className={styledContainerStyles}>
          {isLoading ? (
            <SpinnerContainer />
          ) : (
            formattedProperties.map((property: formattedProperty, i: number) => (
              <Spacer key={i} css={{ margin: 'sm' }}>
                <Text asChild>
                  <div className={getStyledTextStyles(i % 2 === 0)}>
                    {property.formattedName && `${property.formattedName} `}
                    {property.formattedAddress}
                  </div>
                </Text>
              </Spacer>
            ))
          )}
        </Box>
      }
    />
  );
};

// @ts-ignore
const mapStateToProps = (state) => ({
  properties: state.userManagement.currentUser.properties,
  isLoading: state.userManagement.currentUser.propertiesLoadingState === LoadingConstants.LOADING,
});

export default connect(mapStateToProps)(UserManagementPropertyListModal);
